import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type FileIconType = 'folder' | 'pdf' | 'xls' | 'xlsx' | 'doc' | 'docx' | 'csv';
export type FileIconSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'educare-file-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.component.scss']
})
export class FileIconComponent {
  @Input() iconType: FileIconType = 'doc';
  @Input() size: FileIconSize = 'medium';
  @Input() containerClass = '';
}
